import { Common } from '../common';
import { CreateValues, Organization } from '../models/organization';
import { SamlSetting } from '../models/samlSetting';
import { User } from '../models/user';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async create(toAdd: CreateValues): Promise<Organization> {
    const url = this.common.constructPath('/organizations');
    const { organization } = await this.common.postJSON(url, toAdd);
    return organization;
  }

  async findAll(): Promise<Organization[]> {
    const url = this.common.constructPath('/organizations');
    const { organizations } = await this.common.getJSON(url);
    return organizations;
  }

  async findOneById(id: string): Promise<Organization> {
    const url = this.common.constructPath(`/organizations/${id}`);
    const { organization } = await this.common.getJSON(url);
    return organization;
  }

  async findUsersByOrganizationId(id: string): Promise<User[]> {
    const url = this.common.constructPath(`/organizations/${id}/users`);
    const { users } = await this.common.getJSON(url);
    return users;
  }

  async update(id: string, values: CreateValues): Promise<Organization> {
    const url = this.common.constructPath(`/organizations/${id}`);
    const { organization } = await this.common.patchJSON(url, values);
    return organization;
  }

  async remove(id: string): Promise<number> {
    const url = this.common.constructPath(`/organizations/${id}`);
    return this.common.deleteJSON(url);
  }

  async setSsoEnabled(id: string, ssoEnabled: boolean): Promise<Organization> {
    const url = this.common.constructPath(`/organizations/${id}/sso`);
    const { organization } = await this.common.patchJSON(url, {
      ssoEnabled,
    });
    return organization;
  }

  async findSamlSetting(organizationId: string): Promise<SamlSetting> {
    const url = this.common.constructPath(
      `/organizations/${organizationId}/saml-setting`,
    );
    const { samlSetting } = await this.common.getJSON(url);
    return samlSetting;
  }
}
